var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3606 4.69238L9.42307 0.192375C9.31619 0.070875 9.16207 0 9.00007 0C8.83807 0 8.68394 0.070875 8.57707 0.192375L4.63957 4.69238C4.49444 4.85887 4.45844 5.094 4.55069 5.29537C4.64182 5.49562 4.84207 5.625 5.06257 5.625H7.31257V12.9375C7.31257 13.248 7.56457 13.5 7.87507 13.5H10.1251C10.4356 13.5 10.6876 13.248 10.6876 12.9375V5.625H12.9376C13.1581 5.625 13.3583 5.49675 13.4494 5.29537C13.5406 5.094 13.5068 4.85775 13.3606 4.69238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 12.375V15.75H2.8125V12.375H0.5625V16.875C0.5625 17.4971 1.0665 18 1.6875 18H16.3125C16.9346 18 17.4375 17.4971 17.4375 16.875V12.375H15.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.96f55d8c9195a6f0bbbe54ea48dff3dc.svg";
export { ForwardRef as ReactComponent };